import services from '../config/services';
import axios from 'axios';
import {
	GET_API_MAIN_STATUS, GET_API_SYNC_STOCK_STATUS, GET_API_SYNC_GENERAL_STATUS,
	GET_API_STADISTICS_STATUS, GET_JOB_LOGS, GET_ERRORS
} from "./types";
import { getErrorMessage } from "../utils/util.errors";

const URL_MAIN_API_STATUS         = process.env.REACT_APP_API_URL            + services.apiStatus;
const URL_STADISTICS_API_STATUS   = process.env.REACT_APP_API_STATISTICS_URL + '/v1' + services.apiStatus;
const URL_SYNC_STOCK_API_STATUS   = process.env.REACT_APP_SYNC_STOCK_URL     + services.apiStatus;
const URL_SYNC_GENERAL_API_STATUS = process.env.REACT_APP_SYNC_GENERAL_URL   + services.apiStatus;
const URL_JOB_LOGS                = process.env.REACT_APP_API_URL            + services.logJobs;

export const getMainApiStatus = () => dispatch => {
	axios
		.get(URL_MAIN_API_STATUS)
		.then((res) => {
			dispatch({
				type: GET_API_MAIN_STATUS,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const getStadisticApiStatus = () => dispatch => {
	axios
		.get(URL_STADISTICS_API_STATUS)
		.then((res) => {
			dispatch({
				type: GET_API_STADISTICS_STATUS,
				payload: res.data.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const getSyncStockApiStatus = () => dispatch => {
	axios
		.get(URL_SYNC_STOCK_API_STATUS)
		.then((res) => {
			dispatch({
				type: GET_API_SYNC_STOCK_STATUS,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const getSyncGeneralApiStatus = () => dispatch => {
	axios
		.get(URL_SYNC_GENERAL_API_STATUS)
		.then((res) => {
			dispatch({
				type: GET_API_SYNC_GENERAL_STATUS,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const getJobLogs = () => dispatch => {
	axios
		.get(URL_JOB_LOGS)
		.then((res) => {

			dispatch({
				type: GET_JOB_LOGS,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}